import { IonSpinner } from '@ionic/react'
import { NotFound, Viewport } from 'presentation/components'
import React from 'react'
import { useRecoilValue } from 'recoil'
import Pagination from '../../../../components/pagination/pagination'
import { dashboardAtom } from '../../dashboard-atom'
import { HeadingFilter } from '../heading/heading-atom'
import { ReportsItem } from './reports-item/reports-item'
import './reports-list.scss'

interface ReportsListProps {
  search: string
  onGetPage: (pageNumber: number) => void
  filters: HeadingFilter
}

const ReportsList: React.FC<ReportsListProps> = (props) => {
  const state = useRecoilValue(dashboardAtom)

  const reportsListEmpty = !state.reports || !state.reports.length
  const emptyReports = !state.isLoadingReports && reportsListEmpty
  const hasFilter = props.filters && Object.keys(props.filters).length
  const filterNotFound = emptyReports && (hasFilter || !!props?.search)

  return (
    <section className="reports-list">
      <Viewport size="medium">
        <table>
          <thead>
            <tr className="reports-list-header">
              <th>Clinic</th>
              <th>Patient</th>
              <th>Cancer Type</th>
              <th>Treatment</th>
              <th>Status</th>
              <th>Oncologist</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {state.isLoadingReports && (
              <tr>
                <td colSpan={7}>
                  <IonSpinner name="dots" />
                </td>
              </tr>
            )}

            {emptyReports && (
              <tr className="reports-list-item-notfound">
                <td colSpan={7}>
                  {filterNotFound ? (
                    <NotFound>No results for your search</NotFound>
                  ) : (
                    <>
                      <NotFound>You don{"'"}t have reports yet. Wait for the patients to be added to the system</NotFound>
                    </>
                  )}
                </td>
              </tr>
            )}

            {!state.isLoadingReports &&
              state.reports &&
              state.reports.map((report, index) => (
                <ReportsItem key={index} index={index} reportItem={report} onClick={() => null}  />
              ))}
          </tbody>
        </table>

        {!state.isLoadingReports && (state.pageOptions?.quantity as number) > 1 ? (
          <Pagination
            currentPage={state.pageOptions?.current as number}
            quantity={state.pageOptions?.quantity as number}
            onNewPage={props.onGetPage}
          />
        ) : (
          ''
        )}
      </Viewport>
    </section>
  )
}

export default ReportsList
